import { render } from "./MatchRequests.vue?vue&type=template&id=1cfeb1f8&scoped=true"
import script from "./MatchRequests.vue?vue&type=script&lang=js"
export * from "./MatchRequests.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cfeb1f8"]])

export default __exports__